<template>
  <div class="notice_section">
    <div class="notice_title mb10">
      <img src="/images/ic/comm/ic-info.svg" alt=""/>
      <p class="txt_subtitle_1 --grey60">{{ $t('my.payment.detailsOfUsage.notice') }}</p>
    </div>
    <div class="notice_contents">
      <ul class="txt_body_1">
        <li class="--grey60">• Notice - text area text area text area text area text area text area text area text area,
          text area text area text area text area text area text area text area text area
          text area text area text area text area text area text area text area text area text area text area text area
          text area text area text area text area text area
        </li>
        <li class="--grey60">• Notice - text area text area text area text area text area text area text area text
          area
        </li>
        <li class="--grey60">• Notice - text area text area text area text area text area text area text area text
          area
        </li>
        <li class="--grey60">• Notice - text area text area text area text area text area text area text area text
          area
        </li>
        <li class="--grey60">• Notice - text area text area text area text area text area text area text area text
          area
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NoticeSection',
  data() {
    return {}
  }
}
</script>
<style lang="scss">
.notice_section {
  background: var(--grey10);
  padding: 30px;
  margin-top: 30px;

  .notice_title {
    display: flex;
    align-items: center;

    img {
      margin-right: 6px;
    }
  }
}
</style>